import React from 'react';
import cx from 'classnames';

export default class SideScrollableContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    /* eslint react/no-did-mount-set-state: 0 */
    this.hasScrollContent = this.refs.root.clientWidth < this.refs.root.scrollWidth;
    if (this.hasScrollContent) this.setState({showRightButton: true});
  }

  scroll(distance) {
    this.refs.root.scrollLeft += distance;
  }

  onScroll() {
    const rightSideX = this.refs.root.scrollLeft + this.refs.root.clientWidth;
    if (this.refs.root.scrollWidth <= rightSideX + 5) {
      this.setState({showRightButton: false});
    } else if (!this.state.showRightButton) {
      this.setState({showRightButton: true});
    }

    if (this.refs.root.scrollLeft === 0) {
      this.setState({showLeftButton: false});
    } else if (!this.state.showLeftButton) {
      this.setState({showLeftButton: true});
    }
  }

  render() {
    return (
      <div className={cx('side-scrollable-container', this.props.className)} >
        { this.state.showRightButton && <button onClick={() => this.scroll(this.refs.root.clientWidth / 2)} className="scroll-button">
          <div className="icon icon-arrow-right"/>
        </button> }
        { this.state.showLeftButton && <button onClick={() => this.scroll(-this.refs.root.clientWidth / 2)} className="scroll-button left">
          <div className="icon icon-arrow-right"/>
        </button> }
        <div className="scroll-area" onScroll={() => this.onScroll()} ref="root">
          { this.props.children }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Video/SideScrollableContainer.jsx